import React from 'react'

export const OutlinedButtonIllustration = (
  props: React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.213 101.689L189.17 101.731L189.117 101.761L106.303 149.574C105.358 150.12 104.15 150.379 102.971 150.379C101.791 150.379 100.585 150.12 99.6396 149.575L99.6387 149.574L81.1504 138.899L81.0703 138.854L80.5508 138.212V140.004C80.551 140.416 80.833 140.908 81.541 141.328L100.09 152.329C100.843 152.776 101.874 153.017 102.936 153.021C103.997 153.024 105.033 152.79 105.796 152.347L188.391 104.413C189.12 103.99 189.41 103.489 189.41 103.071V101.5L189.213 101.689Z"
        fill="var(--saturn-orange)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.959 81.8325L153.916 81.8745L153.863 81.9038L71.0488 129.717C70.1039 130.263 68.8966 130.522 67.7168 130.522C66.5373 130.522 65.3306 130.263 64.3857 129.718L64.3848 129.717L45.8965 119.042L45.8164 118.997L45.2969 118.355V120.147C45.2971 120.559 45.5791 121.051 46.2871 121.471L64.8359 132.472C65.5895 132.919 66.6202 133.16 67.6816 133.164C68.7428 133.167 69.7787 132.933 70.542 132.49L153.137 84.5562C153.866 84.133 154.156 83.6321 154.156 83.2144V81.6431L153.959 81.8325Z"
        fill="var(--saturn-orange)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.162 61.1895L119.119 61.2314L119.066 61.2607L36.252 109.074C35.307 109.62 34.0997 109.879 32.9199 109.879C31.7404 109.879 30.5337 109.62 29.5889 109.075L29.5879 109.074L11.0996 98.3994L11.0195 98.3535L10.5 97.7119V99.5039C10.5002 99.9161 10.7822 100.408 11.4902 100.828L30.0391 111.829C30.7926 112.276 31.8233 112.517 32.8848 112.521C33.9459 112.524 34.9818 112.29 35.7451 111.847L118.34 63.9131C119.069 63.49 119.359 62.9891 119.359 62.5713V61L119.162 61.1895Z"
        fill="var(--saturn-orange)"
      />

      <path
        d="M46.5723 88.7254L91.6391 62.7061"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M81.4336 109.225L126.5 83.2051"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.545 129.173L161.612 103.154"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2842 98.1087C9.58235 97.1258 9.58235 95.5326 11.2842 94.5502L94.0992 46.7369C95.8014 45.7544 98.5603 45.7544 100.263 46.7369L118.751 57.4115C120.453 58.3941 120.453 59.9872 118.751 60.9697L35.9361 108.783C34.2343 109.766 31.475 109.766 29.7732 108.783L11.2842 98.1087Z"
        stroke="currentColor"
      />
      <path
        d="M46.1455 118.61C44.4437 117.627 44.4437 116.034 46.1455 115.052L128.961 67.2384C130.662 66.2558 133.422 66.2558 135.123 67.2384L153.613 77.913C155.314 78.8956 155.314 80.4887 153.613 81.4712L70.7976 129.285C69.0954 130.267 66.3365 130.267 64.6343 129.285L46.1455 118.61Z"
        stroke="currentColor"
      />
      <path
        d="M81.2568 138.556C79.555 137.574 79.555 135.981 81.2568 134.998L164.072 87.1847C165.774 86.2021 168.533 86.2021 170.235 87.1847L188.724 97.8592C190.426 98.8421 190.426 100.435 188.724 101.418L105.909 149.231C104.207 150.214 101.447 150.214 99.7458 149.231L81.2568 138.556Z"
        stroke="currentColor"
      />

      <path
        d="M10 96.3101V99.5129C9.99995 100.168 10.4432 100.798 11.2352 101.268L29.784 112.269C31.4819 113.276 34.2794 113.285 35.9961 112.288L118.591 64.3551C119.404 63.8836 119.859 63.2456 119.859 62.5806V59.8384"
        stroke="currentColor"
      />
      <path
        d="M44.7969 116.944V120.146C44.7968 120.802 45.2401 121.432 46.0321 121.902L64.581 132.903C66.2787 133.909 69.0763 133.918 70.7929 132.922L153.388 84.9889C154.2 84.5174 154.657 83.8794 154.657 83.2144V80.4722"
        stroke="currentColor"
      />
      <path
        d="M80.0664 136.78V139.983C80.0664 140.639 80.5098 141.268 81.3019 141.738L99.8509 152.739C101.549 153.745 104.346 153.754 106.063 152.758L188.658 104.825C189.47 104.354 189.926 103.716 189.926 103.051V100.308"
        stroke="currentColor"
      />
      <mask
        id="mask0_634_5691"
        maskUnits="userSpaceOnUse"
        x="25"
        y="90"
        width="20"
        height="11"
      >
        <path
          d="M35.0101 90.1114L25.7656 95.4487L35.0101 100.786L44.2545 95.4487L35.0101 90.1114Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_634_5691)">
        <g clipPath="url(#clip0_634_5691)">
          <path
            d="M39.052 93.3679C39.2185 93.464 39.2185 93.62 39.052 93.7162C38.8854 93.8123 38.6152 93.8123 38.4487 93.7162L35.7357 92.1498C35.5691 92.0536 35.5691 91.8977 35.7357 91.8015C35.9023 91.7053 36.1724 91.7053 36.339 91.8015L39.052 93.3679ZM40.8348 94.5187C40.8281 94.5687 40.6483 95.7552 38.5995 96.9381C36.5508 98.1209 34.4957 98.2247 34.4091 98.2285C34.1743 98.239 33.9692 98.1375 33.9511 98.0018C33.933 97.8665 34.108 97.7482 34.3424 97.7374C34.375 97.7358 36.1909 97.632 37.9962 96.5897C39.8242 95.5343 39.9826 94.4914 39.984 94.481C40.0018 94.3455 40.2072 94.2438 40.4421 94.2543C40.677 94.2647 40.8528 94.3831 40.8348 94.5187ZM29.7028 95.6329C29.5362 95.5368 29.5362 95.3808 29.7027 95.2846C29.8694 95.1884 30.1395 95.1884 30.306 95.2846L33.019 96.851C33.1856 96.9471 33.1856 97.1031 33.019 97.1993C32.8524 97.2954 32.5823 97.2954 32.4157 97.1993L29.7028 95.6329ZM30.6077 94.4138C30.4411 94.3177 30.4411 94.1617 30.6077 94.0655C30.7743 93.9693 31.0444 93.9693 31.211 94.0655L35.2408 96.3921C35.4074 96.4883 35.4074 96.6443 35.2408 96.7405C35.0743 96.8366 34.8041 96.8366 34.6375 96.7405L30.6077 94.4138ZM31.9633 93.4549C31.7966 93.3587 31.7967 93.2028 31.9633 93.1066C32.1299 93.0104 32.3999 93.0104 32.5666 93.1066L36.9404 95.6319C37.107 95.728 37.107 95.884 36.9404 95.9802C36.7739 96.0764 36.5037 96.0764 36.3372 95.9802L31.9633 93.4549ZM33.6242 92.6723C33.4576 92.5761 33.4576 92.4202 33.6242 92.324C33.7907 92.2278 34.0609 92.2278 34.2275 92.324L38.2573 94.6506C38.4239 94.7468 38.4239 94.9027 38.2573 94.9989C38.0907 95.0951 37.8206 95.0951 37.654 94.9989L33.6242 92.6723ZM34.152 90.4518L27.365 94.3703C26.7403 94.731 26.7403 95.3158 27.365 95.6765L34.1521 99.5949C34.7768 99.9556 35.7897 99.9556 36.4144 99.595L43.2014 95.6765C43.8261 95.3158 43.8261 94.731 43.2014 94.3703L36.4144 90.4518C35.7897 90.0911 34.7767 90.0911 34.152 90.4518Z"
            fill="#1F8DED"
          />
        </g>
      </g>
      <mask
        id="mask1_634_5691"
        maskUnits="userSpaceOnUse"
        x="60"
        y="110"
        width="20"
        height="12"
      >
        <path
          d="M69.8714 110.61L60.627 115.948L69.8714 121.285L79.1159 115.948L69.8714 110.61Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_634_5691)">
        <g clipPath="url(#clip1_634_5691)">
          <path
            d="M72.4448 118.236L68.309 120.623L67.4634 115.36L72.4448 118.236Z"
            fill="#16140C"
          />
          <path
            d="M73.1308 115.457C74.273 114.797 76.1216 114.796 77.2611 115.454L73.1258 117.842C71.9863 117.184 71.9887 116.116 73.1308 115.457Z"
            fill="#16140C"
          />
          <path
            d="M71.3385 116.81L66.3565 113.934L70.4923 111.546L71.3385 116.81Z"
            fill="#16140C"
          />
          <path
            d="M65.6749 114.327C66.8145 114.985 66.8127 116.053 65.6705 116.712C64.5283 117.372 62.6786 117.373 61.5391 116.715L65.6749 114.327Z"
            fill="#16140C"
          />
        </g>
      </g>
      <path
        d="M79.0255 87.1808C78.919 87.1194 78.7466 87.1194 78.6401 87.1808C78.534 87.2422 78.534 87.3418 78.6401 87.4032L79.0255 87.1808ZM83.8403 90.3403C83.9909 90.3403 84.1128 90.2699 84.1128 90.183V88.7678C84.1128 88.6809 83.9909 88.6105 83.8403 88.6105C83.6897 88.6105 83.5678 88.6809 83.5678 88.7678V90.0258H81.3891C81.2385 90.0258 81.1166 90.0962 81.1166 90.183C81.1166 90.2699 81.2385 90.3403 81.3891 90.3403H83.8403ZM78.8328 87.292L78.6401 87.4032L83.6476 90.2943L83.8403 90.183L84.033 90.0719L79.0255 87.1808L78.8328 87.292Z"
        fill="currentColor"
      />
      <path
        d="M114.581 107.571C114.474 107.51 114.302 107.51 114.195 107.571C114.089 107.632 114.089 107.732 114.195 107.793L114.581 107.571ZM119.395 110.73C119.545 110.73 119.667 110.66 119.667 110.573V109.158C119.667 109.071 119.545 109.001 119.395 109.001C119.245 109.001 119.123 109.071 119.123 109.158V110.416H116.944C116.794 110.416 116.672 110.486 116.672 110.573C116.672 110.66 116.794 110.73 116.944 110.73H119.395ZM114.388 107.682L114.195 107.793L119.203 110.684L119.395 110.573L119.588 110.462L114.581 107.571L114.388 107.682Z"
        fill="currentColor"
      />
      <mask
        id="mask2_634_5691"
        maskUnits="userSpaceOnUse"
        x="94"
        y="130"
        width="19"
        height="11"
      >
        <path
          d="M103.496 130.226L94.252 135.563L103.496 140.901L112.741 135.563L103.496 130.226Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_634_5691)">
        <g clipPath="url(#clip2_634_5691)">
          <path
            d="M99.8068 133.632C99.5931 133.756 99.5931 133.956 99.8068 134.079L102.644 135.717L99.8068 137.356C99.5931 137.479 99.5931 137.679 99.8068 137.802C100.02 137.926 100.367 137.926 100.581 137.802L103.418 136.164L106.256 137.802C106.47 137.926 106.816 137.926 107.03 137.802C107.243 137.679 107.243 137.479 107.03 137.356L104.192 135.717L107.03 134.079C107.243 133.956 107.243 133.756 107.03 133.632C106.816 133.509 106.47 133.509 106.256 133.632L103.418 135.27L100.581 133.632C100.367 133.509 100.02 133.509 99.8068 133.632Z"
            fill="#2F2F30"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_634_5691">
          <rect
            width="10.4493"
            height="10.4493"
            fill="white"
            transform="matrix(0.866025 -0.5 0.866025 0.5 26.2344 95.0234)"
          />
        </clipPath>
        <clipPath id="clip1_634_5691">
          <rect
            width="10.4493"
            height="10.4493"
            fill="white"
            transform="matrix(0.866025 -0.5 0.866025 0.5 60.3594 116.089)"
          />
        </clipPath>
        <clipPath id="clip2_634_5691">
          <rect
            width="9.53183"
            height="9.53183"
            fill="white"
            transform="matrix(0.866025 -0.5 0.866025 0.5 95.1641 135.717)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
